import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { useApiBaseUrl } from '../context/ApiContext';



const PreOrders = ({selectedCustomerId, usernameEmail}) => {
  const ApiBaseUrl = useApiBaseUrl();

  const [orders, setOrders] = useState([]);
  //   { PreOrderItemId: 815, itemNo: 'F-250201', description: 'Coffee Vanilla Tripel 1/6 bbl keg', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 814, itemNo: 'F-250200', description: 'Coffee Vanilla Tripel 6/4/16 oz can', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 813, itemNo: 'F-001258', description: 'Crown Town Ale 1/2 bbl keg', brewery: 'Unknown', shipDate: '2025-03-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 812, itemNo: 'F-001219', description: 'Crown Town Ale 1/6 bbl keg', brewery: 'Unknown', shipDate: '2025-03-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 811, itemNo: 'F-250027', description: 'Nitro Ale 4/6/12 oz can', brewery: 'Unknown', shipDate: '2025-03-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 810, itemNo: 'F-250034', description: 'Espresso Martini Stout 1/6 bbl keg', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 809, itemNo: 'F-250033', description: 'Espresso Martini Stout 6/4/12 oz btl', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 808, itemNo: 'F-240082', description: 'Quirk Blueberry Slam 1/2 bbl keg', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 807, itemNo: 'F-240083', description: 'Quirk Blueberry Slam 1/6 bbl keg', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  //   { PreOrderItemId: 806, itemNo: 'F-240081', description: 'Quirk Blueberry Slam 2/12/12 oz can', brewery: 'Unknown', shipDate: '2025-02-03', qty: 0, uom: 'Piece' },
  // ]);

  
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  // First useEffect for initial orders
  useEffect(() => {
    let isMounted = true;
    const fetchOrders = async () => {
      try {
        if (!selectedCustomerId) return;
        
        console.log('Fetching initial orders...'); // Debug log
        const response = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/Get_AuthorizedPreOrderItems_ByCustomerId`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        
        if (isMounted) {
          setOrders(data.map(item => ({
            PreOrderItemId: item.PreOrderItemId,
            itemNo: item.No_,
            description: item.Description,
            brewery: item.Brewery,
            shipDate: item.FirstShipDate,
            qty: 0,
            uom: item.No_ === 'F-270029' ? 'Pallet' : 'Piece'
          })));
          setInitialLoadComplete(true);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    fetchOrders();
    return () => { isMounted = false; };
  }, [selectedCustomerId]);

  // Second useEffect for open pre-orders
  useEffect(() => {
    let isMounted = true;
    const fetchOpenPreOrders = async () => {
      try {
        if (!selectedCustomerId || !orders.length) return;

        const openPreOrders = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/GetOpenPreOrders`);
        const openPreOrdersData = await openPreOrders.json();
        console.log('Received open pre-orders:', openPreOrdersData);

        if (isMounted) {
          setOrders(prevOrders => {
            // Create Map using PreOrderItemId as the only key
            const existingOrdersMap = new Map(prevOrders.map(order => [order.PreOrderItemId, order]));
            
            // Process each pre-order
            openPreOrdersData.forEach(preOrder => {
              const existingOrder = existingOrdersMap.get(preOrder.preOrderItemId);
              if (existingOrder) {
                // Update quantity for existing order
                existingOrder.qty = parseInt(preOrder.preOrderQty) || 0;
              } else {
                // Add new pre-order
                existingOrdersMap.set(preOrder.preOrderItemId, {
                  PreOrderItemId: preOrder.preOrderItemId,
                  itemNo: preOrder.no_,
                  description: preOrder.description,
                  brewery: preOrder.brewery,
                  shipDate: preOrder.firstShipDate,
                  qty: parseInt(preOrder.preOrderQty) || 0,
                  uom: preOrder.no_ === 'F-270029' ? 'Pallet' : 'Piece'
                });
              }
            });
            
            return Array.from(existingOrdersMap.values());
          });
        }
      } catch (error) {
        console.error('Error fetching open pre-orders:', error);
      }
    };

    fetchOpenPreOrders();
    return () => { isMounted = false; };
  }, [orders.length, selectedCustomerId, ApiBaseUrl]);

  const [submitted, setSubmitted] = useState(false);

  const handleQtyChange = (index, event) => {
    const value = parseInt(event.target.value) || 0;
    setOrders(prevOrders => {
      const newOrders = [...prevOrders];
      newOrders[index] = { ...newOrders[index], qty: value };
      return newOrders;
    });
  };

  const handleSubmitPreOrders = async () => {
    try {
      const filteredOrders = orders.map(order => ({
          preOrderItemId: order.PreOrderItemId,
          itemNo: order.itemNo,
          description: order.description,
          brewery: order.brewery,
          qty: order.qty,
      }));
  
      const response = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/InsertPreOrderQtys`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filteredOrders),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response;
      console.log('Order submitted successfully:', data);
      setSubmitted(true);

      const response2 = await fetch(`${ApiBaseUrl}/api/Sales/${usernameEmail}/${selectedCustomerId}/SendPreOrderConfirmationEmail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filteredOrders),
      });
  
      if (!response2.ok) {
        throw new Error('Network response was not ok');
      }

    } catch (error) {
      console.error('Error submitting order:', error);
    }
  };

  const renderInputField = (order, index) => {
    console.log('Rendering input for order:', {
      itemNo: order.itemNo,
      qty: order.qty,
      type: typeof order.qty
    });
    
    return (
      <input
        type="number"
        value={order.qty || 0}
        onChange={(event) => handleQtyChange(index, event)}
        style={{ width: '60px' }}
        min="0"
      />
    );
  };

  return (
    <>
      <Grid container spacing={2} style={{marginTop: '64px'}}>
        <Grid item xs={12} sm={3}>
          {/* First smaller column */}
        </Grid>
        <Grid item xs={12} sm={5}>
          {/* Middle larger column */}
          <div style={{marginTop: "32px", marginBottom: '32px'}}>
            Please only submit this one time. You will receive an email confirmation once your pre-order submission has been received.
          </div>
          <table>
            <thead>
              <tr>
                <th>Item No.</th>
                <th>Description</th>
                <th>Ship Date</th>
                <th>Qty</th>
                <th>UOM</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={index}>
                  <td>{order.itemNo}</td>
                  <td>{order.description}</td>
                  <td>{new Date(order.shipDate).toLocaleDateString()}</td>
                  <td>
                    {renderInputField(order, index)}
                  </td>
                  <td>{order.uom}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{marginTop: '64px'}}>
            {!submitted ? (
              <button style={{ height: '50px', width: '256px', backgroundColor: 'lightgreen', cursor: 'pointer' }}
                onClick={handleSubmitPreOrders}>
                Submit
              </button>
              ) : (
                <div>Thank you for submitting your pre-orders! Please only do this once.</div>
              )}
          </div>
          {/* <div style={{ marginTop: '32px', textAlign: 'center' }}>
            <h3 style={{ marginBottom: '16px' }}>Pre-Order Summary</h3>
            <ul style={{ listStyleType: 'none', padding: 0, marginLeft: '246px' }}>
              {orders.map((order, index) => (
                <li key={index} style={{ marginBottom: '8px' }}>
                  <strong>Item No:</strong> {order.itemNo}, <strong>Qty:</strong> {order.qty}
                </li>
              ))}
            </ul>
          </div>
           */}
        </Grid>
        <Grid item xs={12} sm={3}>
          {/* Third smaller column */}
        </Grid>
      </Grid>
    </>
  );
};

export default PreOrders;
